import styled from "styled-components";
import {Text1, Title2} from "../../styles/components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  margin-bottom: 10vh;
  padding: 5vh 1vw;
  color: ${({theme}) => theme.colors.black};

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    padding: 5vh 12%;
  }
`

export const Br = styled.div`
  margin-top: 30px;
`

export const Title = styled(Title2)`
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  margin-bottom: 40px;
`

export const SupportTitle = styled.h2`
  color: ${({theme}) => theme.colors.title};
  text-transform: uppercase;
  margin-bottom: 2rem;
`

export const ModalTitle = styled(Title2)`
  display: inline-block;
  margin-bottom: 2rem;
`

export const SubText = styled(Text1)`
  display: block;
  color: ${({theme}) => theme.colors.text};
  text-align: center;
  margin-bottom: 100px;
`

export const SupportText = styled(SubText)`
  text-align: left;
  margin-bottom: 2rem;    
`

export const Image = styled.img`
  display: none;
  width: 90%;
  height: auto;

  @media only screen and (${({theme}) => theme.media.large}) {
    display: block;
  }
  
  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    float: right;
  }

  @media only screen and (min-width: 1800px) {
    width: 60%;
  }
`

export const SupportBlock = styled.div`
    margin-top: 100px;
`

export const ModalBody = styled.div`
  text-align: center;
`

